import React from "react";
import styled from "styled-components";

import calculator from "../assets/Images/calculator.png";

const Section = styled.section`
  position: relative;
  min-height: 100vh;
  width: 80vw;
  display: flex;

  margin: 0 auto;

  @media (max-width: 48em) {
    width: 90vw;
  }
  @media (max-width: 30em) {
    width: 100vw;
  }
`;
const Title = styled.h1`
  font-size: ${(props) => props.theme.fontBig};
  font-family: "Kaushan Script";
  font-weight: 300;

  position: absolute;
  top: 1rem;
  left: 5%;
  z-index: 5;

  @media (max-width: 64em) {
    font-size: ${(props) => `calc(${props.theme.fontBig} - 5vw)`};
    top: 0;
    left: 0;
  }
  @media (max-width: 48em) {
    font-size: ${(props) => props.theme.fontxxxl};
  }
`;
const Left = styled.div`
  width: 50%;
  font-size: ${(props) => props.theme.fontlg};
  font-weight: 300;
  position: relative;
  z-index: 5;
  margin-top: 20%;

  @media (max-width: 64em) {
    width: 80%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) !important;
    margin: 0 auto;

    padding: 2rem;
    font-weight: 600;

    backdrop-filter: blur(2px);
    background-color: ${(props) => `rgba(${props.theme.textRgba},0.4)`};
    border-radius: 20px;
  }

  @media (max-width: 48em) {
    font-size: ${(props) => props.theme.fontmd};
  }
  @media (max-width: 30em) {
    font-size: ${(props) => props.theme.fontsm};
    width: 70%;
  }
`;
const Right = styled.div`
  width: 50%;
  position: relative;
  img {
    width: 100%;
    height: auto;
  }

  @media (max-width: 64em) {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      height: 100vh;
      object-fit: cover;
    }
  }
`;

const About = () => {
  return (
		<Section id="fixed-target" className="about">
			<Title
				data-scroll
				data-scroll-speed="-2"
				data-scroll-direction="horizontal"
			>
				Little Intro...
			</Title>
			<Left data-scroll data-scroll-sticky data-scroll-target="#fixed-target">
				Cubilia molestiae auctor ipsum molestiae diamlorem! Mattis corrupti
				eligendi nemo, sagittis laboriosam! Potenti praesent voluptatem
				praesentium dapibus eius. Aptent enim qui inventore class ullamco totam
				orci. Risus primis sodales montes, doloribus totam distinctio vivamus
				laborum pulvinar viverra lorem libero voluptatem minus rem eu sapien
				semper tempor magna nam varius proident.
				<br />
				<br />
				Cubilia molestiae auctor ipsum molestiae diamlorem! Mattis corrupti
				eligendi nemo, sagittis laboriosam! Potenti praesent voluptatem
				praesentium dapibus eius. Aptent enim qui inventore class ullamco totam
				orci. Risus primis sodales montes, doloribus totam distinctio vivamus
				laborum pulvinar viverra lorem libero voluptatem minus rem eu sapien
				semper tempor magna nam varius proident.
			</Left>
			<Right>
				<img src={calculator} alt="About Us" />
			</Right>
		</Section>
	);
};

export default About;
